import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

export interface IUserReviewsProps {
    title: string;
    cssClasses?: string;
    children: React.ReactNode;
}

const UserReviews: FC<IUserReviewsProps> = ({title, cssClasses, children}) => {
	return (
		<div className={classNames(styles.userReviews, cssClasses)}>
			<h4 className={styles.title}>{title}</h4>
			<div className={styles.content}>{children}</div>
		</div>
	);
};

export default UserReviews;
